import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

export interface TabProps {
  text: React.ReactNode | React.JSX.Element; // Still called text due to legacy
  path: string;
  /* DEPRECATED! */
  key?: string;
  disabled?: boolean;
}

export default function Tab({ text, path, disabled }: TabProps) {
  const location = useLocation();

  const selectedStyle = useMemo(() => {
    if (!location.pathname.includes(path)) return '';

    return 'border-b border-primary-600 text-primary-600';
  }, [path, location]);

  const disabledStyle = useMemo(() => {
    if (disabled) return 'text-disabled';

    return 'text-black';
  }, [disabled]);

  return (
    <li className={`${selectedStyle} ${disabledStyle} select-none py-1 text-sm font-medium`}>
      {disabled ? (
        <p>{text}</p>
      ) : (
        <Link to={path} role='tab'>
          {text}
        </Link>
      )}
    </li>
  );
}
